<template>
  <component :is="tag" :class="rowClass" class="tq-row">
    <slot></slot>
  </component>
</template>

<script lang="ts">
import { bem } from "../../../utils/bem";


export default {
  name: 'TqRow',
  provide() {
    return {
      TqRow: this,
    };
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    wrap: {
      type: Boolean,
      default: true,
    },
    align: String,
    gutter: {
      type: [String, Number, Array],
      default: 0,
    },
    justify: String,
  },

  data() {
    return {
      children: []
    };
  },

  computed: {
    rowClass() {
      const justifyClass = this.justify ? `justify-${this.justify}` : '';
      const alignClass = this.align ? `align-${this.align}` : '';
      return bem('tq-row', [justifyClass, alignClass, `${this.wrap ? '' : 'nowrap'}`]);
    },

    groups() {
      const groups:any = [[]];
      let totalSpan = 0;
      this.children.forEach((child:any, index:number) => {
        totalSpan += Number(child.span);

        if (totalSpan > 24) {
          groups.push([index]);
          totalSpan -= 24;
        } else {
          groups[groups.length - 1].push(index);
        }
      });

      return groups;
    },
    firstGroup() {
      return this.groups[0];
    },
    firstGroupLength() {
      return this.firstGroup.length;
    },

    spaces() {
      let gutter = 0;
      if (Array.isArray(this.gutter)) {
        gutter = Number(this.gutter[0]) || 0;
      } else {
        gutter = Number(this.gutter);
      }

      const spaces:any[] = [];
      if (!gutter) return spaces;

      this.groups.forEach((group:any) => {
        const averagePadding = (gutter * (this.firstGroupLength - 1)) / this.firstGroupLength;
        // const averagePadding = (gutter * (group.length - 1)) / group.length;

        group.forEach((item:any, index:number) => {
          if (index === 0) {
            spaces.push({ right: averagePadding } as never);
          } else {
            const left = gutter - spaces[item - 1].right;
            const right = averagePadding - left;
            spaces.push({ left, right } as never);
          }
        });
      });

      return spaces;
    },

    verticalSpaces() {
      const spaces:any[] = [];
      if (Array.isArray(this.gutter) && this.gutter.length > 1) {
        const bottom = Number(this.gutter[1]) || 0;
        if (bottom <= 0) return spaces;

        this.groups.forEach((group:any, index:number) => {
          if (index === this.groups.length - 1) return;
          group.forEach(() => {
            spaces.push({ bottom });
          });
        });
      }
      return spaces;
    },
  },

  created() {
  },
};
</script>
